import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

// NOTE : everytime new static image component is created here please add it to the solutionsImagesArray at the bottom
export const ScheduleADemo= () => {
    return (
      <StaticImage
        src="../images/schedule-a-demo.png"
        alt="Schedule a Demo"
        placeholder="blurred"
        loading="lazy"
        quality={100}
        style={{
          position: "relative",
            width: "auto",
            maxHeight: "100%",
            zIndex: "-10",
            margin: "auto"
            }}
      />
    )
}

export const TocBackground= () => {
  return (
    <StaticImage
      src="../images/toc-background.png"
      alt="toc-background"
      placeholder="blurred"
      quality={100}
      style={{
          zIndex: "-10",
          margin: "auto"
          }}
    />
  )
}

export const SquareCheck= () => {
  return (
    <StaticImage
      src="../images/square-check.png"
      alt="square-check"
      quality={100}
      style={{
          margin: "auto"
          }}
    />
  )
}
export const TocDots= () => {
  return (
    <StaticImage
      src="../images/toc-dots.png"
      alt="toc-dots"
      quality={100}
      style={{
          margin: "auto",
          position: "absolute",
          left: "5%",
          top: "-45%",
          opacity: ".3",
          zIndex: "-1",
          }}
    />
  )
}

export const resourcesImagesArray = [
  ScheduleADemo,
  TocBackground,
  SquareCheck,
  TocDots
]

export const handleResourcesImages= (imgAltTag) => {
  for(let i = 0; i < resourcesImagesArray.length; i++){
    if(imgAltTag ===  resourcesImagesArray[i]().props.alt){
      const imageSrc =  resourcesImagesArray[i]()
      return imageSrc;
    }
  }
}
